module.exports = __webpack_public_path__ + "5c114213/img/arrow-left-icon.785c715c.svg";